import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { MenuItem } from './MenuItem';

import { authenticationCentral } from '../../authentication/Authentication';
import { storage, TOKEN_INFO, TOKEN_EXPIRATION, PROFILE_INFO, REDIRECT_TO, SELECTED_APP, SELECTED_PROVIDER } from '../../app/Storage';

export class UserMenu extends Component {
    static contextTypes = {
        cleanEdition: PropTypes.func
    }

    logout() {
        storage.remove(TOKEN_INFO);
        storage.remove(TOKEN_EXPIRATION);
        storage.remove(PROFILE_INFO);
        storage.remove(REDIRECT_TO);
        storage.remove(SELECTED_APP);
        storage.remove(SELECTED_PROVIDER);

        this.context.cleanEdition();

        window.location.href = authenticationCentral.logoutUrl;
    }

    manageAccount() {
        window.open(authenticationCentral.manageAccontUrl);
    }

    render() {
        const { app } = this.props;

        return (
            <div>
                <div onClick={() => this.manageAccount()}>
                    <MenuItem
                        label="Gerir Conta"
                        icon="icon-profile"
                        to="#"
                        app={app} />
                </div>
                <div onClick={() => this.logout()}>
                    <MenuItem
                        label="Logout"
                        icon="icon-logout"
                        to="#"
                        app={app} />
                </div>
            </div>
        );
    }
}
